"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultBuildTokenValue = (inputString) => {
    return inputString.trim();
};
exports.default = defaultBuildTokenValue;
